import { Bar, ComposedChart, LabelList, Legend, Line, Tooltip, XAxis, YAxis } from 'recharts';

export const DocAndHoursChart = ({ docAndHours }: { docAndHours: any[] }) => {

  return (
    <div>
      <p style={{ color: '#54586e', fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
        Quantidade de documentos e soma de horas por dia
      </p>
      <span style={{ color: '#8d95a0', fontSize: 13, fontWeight: 400 }}>
        Número de horas por documento dos colaboradores afastados
      </span>
      <ComposedChart width={1090} height={250} style={{ margin: '20px auto' }} data={docAndHours}>
        <XAxis dataKey="name" />
        <YAxis
          yAxisId="1"
        />
        <YAxis
          orientation="right"
          yAxisId="2"
        />
        <Tooltip />
        <Legend />
        <Legend verticalAlign="top" />
        <Bar dataKey="Documentos" name="Quantidade de documentos enviados" barSize={20} fill="#413ea0" yAxisId="2" />
        <Line type="monotone" dataKey="Horas" name="Soma total de horas dos documentos no dia" stroke="#ff7300" yAxisId="1">
          <LabelList dataKey="Horas" position="top" style={{ fontSize: 12, fill: '#7f8790' }} />
        </Line>
      </ComposedChart>
    </div>

  );
};
